// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.customerInvoiceDetail .el-card__header {\n  padding: 10px;\n  background: #f1f1f1;\n  color: #000;\n}\n.customerInvoiceDetail .el-input.is-disabled .el-input__inner,\n.customerInvoiceDetail .el-range-editor.is-disabled input{\n  color: #000;\n}\n", ""]);
// Exports
module.exports = exports;
